import React from "react";

export function Errorbar() {
  const queryParams = new URLSearchParams(location.search);
  const error = queryParams.get('error');
  const errorMapping = {
    'NO_SELECTION': 'Please draw an outline around the rooster(s) and give them a name!',
    'NO_ROOSTERS': 'No roosters found'
  }
  const shouldShow = (error && errorMapping[error]) ? true : false;

  return shouldShow ? (
    <>
      <div role="alert" className="alert alert-warning bg-orange-400 text-black flex justify-center items-center rounded-none">
        <svg xmlns="http://w3.org" className="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{errorMapping[error]}</span>
      </div>
    </>
  ) : (<></>);
}
